module.exports = __webpack_public_path__ + "media/images/athletes/2239-e3357ec7ad9be4d7be5bd28e90bfa341.png";